import './App.css';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import React from 'react';
// Page imports
import Home         from './pages/Home'
import About        from './pages/About'


import { Amplify } from 'aws-amplify';
import config from './aws-exports';

Amplify.configure(config);

function App() {
  return (
    <Router>
      <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/About" element={<About />} />
            <Route path="*" element={<Home />} />
      </Routes>
    </Router>
  );
}

export default App;